import { MapPinned } from "lucide-react";
import { areaGroups, regionById } from "../data/regions";
import type { AreaGroupId, FilterState, Place } from "../data/schema";

interface RegionNavigatorProps {
  places: Place[];
  filters: FilterState;
  onChange: (filters: FilterState) => void;
}

export function RegionNavigator({ places, filters, onChange }: RegionNavigatorProps) {
  const counts = places.reduce(
    (result, place) => {
      const areaGroup = regionById[place.region].areaGroup;
      result[areaGroup] = (result[areaGroup] ?? 0) + 1;
      return result;
    },
    {} as Partial<Record<AreaGroupId, number>>,
  );

  return (
    <section className="region-navigator" aria-labelledby="region-navigator-title">
      <div className="region-navigator-copy">
        <span>전국 탐색</span>
        <h2 id="region-navigator-title">지역으로 찾기</h2>
        <p>가고 싶은 지역을 선택하세요.</p>
      </div>
      <div className="area-group-grid">
        {areaGroups.map((areaGroup) => {
          const count = counts[areaGroup.id] ?? 0;
          const active = filters.areaGroups.includes(areaGroup.id);
          return (
            <button
              aria-pressed={active}
              className={active ? "active" : ""}
              disabled={count === 0}
              key={areaGroup.id}
              onClick={() =>
                onChange({
                  ...filters,
                  areaGroups: active ? [] : [areaGroup.id],
                  regions: [],
                  districts: [],
                })
              }
              type="button"
            >
              <MapPinned size={17} aria-hidden="true" />
              <span>
                <strong>{areaGroup.name}</strong>
                <small>{count > 0 ? areaGroup.description : "여행지 준비 중"}</small>
              </span>
              <b>{count}</b>
            </button>
          );
        })}
      </div>
    </section>
  );
}
